import { BaseTrackingEvent } from "./BaseTrackingEvent";
export var CommonTrackingEvents;
(function (CommonTrackingEvents) {
    class PageViewEvent extends BaseTrackingEvent {
        constructor(data) {
            super();
            Object.assign(this, data);
        }
        toPlain() {
            return { ...this };
        }
    }
    CommonTrackingEvents.PageViewEvent = PageViewEvent;
})(CommonTrackingEvents || (CommonTrackingEvents = {}));
//# sourceMappingURL=CommonTrackingEvents.js.map